import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DialogService } from 'primeng/dynamicdialog';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CxoneOrderManagementNotesModalComponent } from '../cxone-order-management-notes-modal/cxone-order-management-notes-modal.component';

export interface CxoneOrderManagementGridNotesContainerInterface {
    notes?: string,
    order: any,
    gridApi: any,
}

@Component({
    selector: 'cv-cxone-order-management-grid-notes',
    templateUrl: './cxone-order-management-grid-notes.component.html',
    styleUrl: './cxone-order-management-grid-notes.component.scss',
    providers: [DialogService]
})
export class CxoneOrderManagementGridNotesComponent implements ICellRendererAngularComp {
    constructor(
        private dialogSrvc: DialogService,
        private cvLocalizationFactory: CVLocalizationService,
    ) { }
    notes?: string;
    order?: any;
    gridApi?: any;
    hasNotes?: boolean;

    agInit(params: ICellRendererParams<any, any, any> & CxoneOrderManagementGridNotesContainerInterface): void {
        this.notes = params.notes;
        this.order = params.order;
        this.gridApi = params.api;
        if (this.notes === null || this.notes === "" || this.notes === undefined) {
            this.hasNotes = false;
        } else {
            this.hasNotes = true;
        }
    }

    refresh(params: ICellRendererParams<any, any, any>): boolean {
        return false;
    }
    
    getLocalizationString(key: string, defaultValue: string): string { 
        return this.cvLocalizationFactory.getCachedText("Order_Management", key, defaultValue);
    }
    
    openAddNotesModal() {
        this.dialogSrvc.open(CxoneOrderManagementNotesModalComponent, {
            width: "540px",
            height: "398px",
            baseZIndex: 10000,
            styleClass: 'cx-one-ui product-assignment-modal btn-bg-is-white',
            data: {
                noteData: this.notes.trim(),
                order: this.order,
                gridApi: this.gridApi,
                modalTitle: this.getLocalizationString("Add_Note", "Add note"),
                modalPlaceholder: this.getLocalizationString("Add_Notes", "Add notes"),
                modalSaveLabel: this.getLocalizationString("Save", "Save"),
                modalCancelLabel: this.getLocalizationString("Cancel", "Cancel"),
            }
        });
    }
}
